export default __webpack_public_path__ + "static/1-5-2-3-ee3a34f4df7e14051b2dbf948f6baa79.jpg";